import { baseAuthUrl } from "../api";

const patreonClientId =
  "uDUULDaaiDHBAztoQ7AmaBx5BQkaRWvVg7h32IdSbubfOs_fy1vQEQm-kQtYBE1_";

const googleClientId =
  "1036517559710-bh0jd38aeb1ne7q16mbgoh51vlq75t4r.apps.googleusercontent.com";

export const goToLogin = () => {
  const isGoogle = localStorage.getItem("authType") === "google";
  if (isGoogle) {
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${window.location.origin}/login&prompt=consent&response_type=code&client_id=${googleClientId}&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fyoutube+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fyoutube.channel-memberships.creator&access_type=offline`;
  } else {
    window.location.href = `${baseAuthUrl}/oauth2/authorize?response_type=code&client_id=${patreonClientId}&redirect_uri=${window.location.origin}/login`;
  }
};
